import type { AccessibilitySettings } from '../types/accessibility';
import { DEFAULT_ACCESSIBILITY_SETTINGS } from '../types/accessibility';

const STORAGE_KEY = 'bitmiyo_a11y_settings';
const FAB_VISIBLE_KEY = 'bitmiyo_a11y_fab_visible';

/** Tarayıcıda saklanan erişilebilirlik ayarlarını yükler */
export function getAccessibilitySettings(): AccessibilitySettings {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      return { ...DEFAULT_ACCESSIBILITY_SETTINGS, ...JSON.parse(saved) };
    }
  } catch (e) {
    console.error('Erişilebilirlik ayarları okunamadı:', e);
  }
  return DEFAULT_ACCESSIBILITY_SETTINGS;
}

/** Erişilebilirlik ayarlarını kaydeder ve HTML elementine uygular */
export function saveAccessibilitySettings(settings: AccessibilitySettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    applyAccessibilitySettings(settings);
  } catch (e) {
    console.error('Erişilebilirlik ayarları kaydedilemedi:', e);
  }
}

/** Ayarları varsayılana sıfırlar */
export function resetAccessibilitySettings(): AccessibilitySettings {
  saveAccessibilitySettings(DEFAULT_ACCESSIBILITY_SETTINGS);
  return DEFAULT_ACCESSIBILITY_SETTINGS;
}

/** Kayan erişilebilirlik butonunun görünürlüğünü döner (varsayılan: true) */
export function getA11yFabVisible(): boolean {
  try {
    const val = localStorage.getItem(FAB_VISIBLE_KEY);
    if (val === null) return true;
    return val === 'true';
  } catch {
    return true;
  }
}

/** Kayan erişilebilirlik butonunun görünürlüğünü kaydeder */
export function setA11yFabVisible(visible: boolean): void {
  try {
    localStorage.setItem(FAB_VISIBLE_KEY, String(visible));
  } catch { /* ignore */ }
}

/** CSS sınıflarını ve HTML root stilini günceller */
export function applyAccessibilitySettings(settings: AccessibilitySettings): void {
  const root = document.documentElement;

  root.style.fontSize = `${settings.fontSize}%`;

  root.classList.toggle('a11y-high-contrast', settings.highContrast);
  root.classList.toggle('a11y-wide-line-spacing', settings.wideLineSpacing);
  root.classList.toggle('a11y-highlight-links', settings.highlightLinks);
  root.classList.toggle('a11y-easy-reading', settings.easyReading);
}
